import memberHome from './memberHome/memberHome.vue';

const homeRoutes = [
  {
    path: '/',
    component: memberHome,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:view',
    component: memberHome,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '',
    component: memberHome,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/explore',
    name: 'explore',
    redirect: { name: 'clubs' },
  },
  {
    path: '/explore/clubs',
    name: 'clubs',
    component: () => import('@/app/booking/explore/explore.vue'),
    meta: {
      requiresAuth: true,
      title: 'Explore Clubs',
      noAutoScroll: true,
    },
  },
];

export default homeRoutes;
